<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <h2 class="titulo">DETALHES DA VENDA</h2>
        <v-layout wrap class="justify-center">
            <v-flex xs12 md10>
                <div class="d-flex justify-center">
                    <v-row class="mt-2 mb-2">
                        <v-col cols="12" lg="4" class="order-lg-3"> </v-col>
                        <v-col cols="6" lg="4" class="order-lg-2 mx-auto" align-self="center">
                            <ImagemBem v-if="pedido.bem.id_bem" :id-bem="pedido.bem.id_bem" />
                        </v-col>
                        <v-col cols="12" md="6" lg="4" class="order-lg-1 mx-auto">
                            <IndicadorDecisaoCredito
                                    v-show="is_venda_aprovada || is_venda_reprovada || is_venda_pendente || is_venda_pendencia_cadastral"
                                    :is-pendente="is_venda_pendente"
                                    :is-pendencia-cadastral="is_venda_pendencia_cadastral"
                                    :is-reprovada="is_venda_reprovada"
                                    :is-aprovada="is_venda_aprovada"
                                    :motivo="pedido.motivo_decisao_credito"
                                    :id-pedido="pedido.id_pedido"
                            />
                            <v-row>
                                <v-layout v-if="is_venda_pendencia_cadastral && !(is_venda_reprovada || is_venda_aprovada || is_venda_analise)" class="d-flex flex-wrap">

                                    <v-btn v-if="!pedido.defendeu_dados" small class="transition mr-4 mt-4" color="primary" @click="abrirModalDefesa">
                                        Defender Dados
                                    </v-btn>
                                    <v-btn small class="transition mr-4 mt-4" color="primary" @click="abrirModalAlterarDados">
                                        Alterar Dados
                                    </v-btn>
                                </v-layout>
                                <v-layout v-if="houve_pendencia">
                                    <v-btn small class="transition mr-4 mt-4" color="primary" @click="abrirHistoricoPendencias()">
                                        Histórico de Pendências
                                    </v-btn>
                                </v-layout>
                            </v-row>
                        </v-col>
                    </v-row>
                </div>
                <v-col class="d-flex justify-center mb-2"
                       v-if="!isVendaNaoGerada(pedido.status_pedido) && exibe_contrato">
                    <div class="pt-2 align-center">
                        <v-icon class="align-self-center" color="primary">
                            {{
                                getIconStatusContrato(pedido.contrato.status) }}
                        </v-icon>
                        <label class="align-self-center" style="font-weight: bold;">Status do contrato: {{
                            getDescricaoStatusContrato(pedido.contrato.status, pedido.docusign_falha,pedido.docusign_enviado)
                        }}</label>
                    </div>
                </v-col>
                <v-col v-if="pedido.contrato.status !== '' && exibe_contrato"
                       class="d-flex align-center justify-center mb-4 flex-wrap">
                    <div v-if="pedido.contrato.status === StatusContrato.ContratoAssinado"
                         class="btn-contratos mb-2 position-relative">
                        <v-menu offset-y v-model="dropdown_documentos_aberto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" @click="visualizarDocumentos">
                                    Visualizar documentos
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item v-for="(item, index) in documentos" :key="index"
                                             @click="visualizarDocumento(item)">
                                    <v-list-item-title>{{ item }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                    <v-btn class="ml-5 mb-2" v-if="pedido.contrato.status === StatusContrato.ContratoPendente"
                           color="secondary" @click="reenviarContrato">
                        Reenviar contrato
                    </v-btn>
                    <v-btn class="ml-5 mb-2" color="secondary" @click="getHistoricoReenvio">Histórico reenvios</v-btn>
                    <v-btn class="ml-5 mb-2" v-if="pedido.contrato.status === StatusContrato.ContratoAssinado"
                           color="primary" @click="compartilharDocumentos">
                        Compartilhar documentos
                    </v-btn>
                </v-col>
                <div class="mx-1 mt-3 mb-5">
                    <DadosDaCompra :has-error="hasError" :pedido="pedido" :desconto="desconto"
                                   :permite-flavor-todos-produtos="!!permite_flavor_todos_produtos"
                                   :administradora="administradora" :seguro="seguro"
                                   :aguardando-pagamento-cliente="AguardandoPagamentoCliente" label-cota="Quantidade de cotas" />
                </div>
                <div class="mx-1 mt-3 mb-5">
                    <v-layout wrap row-padding v-if="exibirBotoesBoleto()">
                        <v-flex col-12 col-md-6>
                            <v-btn id="ButtonReenviarBoleto" block color="primary" @click="gerarNovoBoleto()">
                                GERAR NOVO
                                BOLETO
                            </v-btn>
                        </v-flex>
                        <v-flex col-12 col-md-6>
                            <v-btn id="ButtonVisualizarBoleto" block color="secondary" @click="verBoleto()">
                                Visualizar
                                boleto
                            </v-btn>
                            <v-btn id="ButtonHistoricoBoleto" block color="secondary" @click="getHistoricoBoleto()"
                                   class="mt-3" v-if="pedido.historico_envio_boleto.length > 0">
                                Histórico de Envio de
                                Boletos
                            </v-btn>
                        </v-flex>
                    </v-layout>
                    <v-row>
                        <v-flex col-12 col-md-6>
                            <v-btn id="ButtonReenviarCodigo" block class="mt-3" v-if="AguardandoPagamentoCliente"
                                   color="primary" @click="openDialogEmail()">
                                Reenviar email com código de pagamento
                            </v-btn>
                        </v-flex>
                        <v-flex col-12 col-md-6>
                            <v-btn id="ButtonHistoricoLink" block color="secondary" @click="getHistoricoLink()"
                                   class="mt-3" v-if="AguardandoPagamentoCliente">
                                Histórico de Envio de Links
                            </v-btn>
                        </v-flex>
                    </v-row>
                </div>
                <div class="mb-5">
                    <v-row class="primary--text ma-1 pointer" @click="sections.cliente = !sections.cliente">
                        <h2>Dados do cliente</h2>
                        <v-spacer />
                        <v-icon color="primary" class="mt-1" :class="{ rotate90: sections.cliente }">
                            chevron_right
                        </v-icon>
                    </v-row>
                    <v-divider />
                    <collapse-transition>
                        <div class="ma-1 my-3" v-show="sections.cliente">
                            <v-layout wrap>
                                <v-flex xs12 md6>
                                    <label>{{ isPessoaFisica() ? "CPF" : "CNPJ" }}</label>
                                    <p>
                                        {{ (isPessoaFisica() ? pedido.cliente.cpf : pedido.cliente.cnpj) || "-" }}
                                    </p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>{{ isPessoaFisica() ? "Nome" : "Razão social" }}</label>
                                    <p>
                                        {{ cliente() }}
                                    </p>
                                </v-flex>
                                <v-flex xs12 md6 v-if="!isPessoaFisica()">
                                    <label>Nome fantasia</label>
                                    <p>
                                        {{ nomeFantasia() }}
                                    </p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>
                                        {{ isPessoaFisica() ? "Data de nascimento" : "Data de fundação" }}
                                    </label>
                                    <p>{{ getData(pedido) }}</p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>{{ isPessoaFisica() ? "Nacionalidade" : "Atividade" }}</label>
                                    <p>
                                        {{ nacionalidadeAtividade() }}
                                    </p>
                                </v-flex>
                                <v-flex xs12 md6 v-if="isPessoaFisica()">
                                    <label>{{ "Sexo" }}</label>
                                    <p>
                                        {{ sexoNomeSocio() }}
                                    </p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>{{ isPessoaFisica() ? "Renda" : "Faturamento médio" }}</label>
                                    <p>{{ getMoney(pedido) }}</p>
                                </v-flex>
                                <v-flex xs12 md6 v-if="isPessoaFisica()">
                                    <label>Politicamente exposto</label>
                                    <p>{{ getPoliticamenteExposto() }}</p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>Telefone</label>
                                    <p>
                                        {{ getTelefone(pedido.cliente, pedido.instancia_cliente) }}
                                    </p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>Celular</label>
                                    <p>{{ getTelefoneCelular(pedido.instancia_cliente, pedido.cliente) }}</p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>E-mail</label>
                                    <p>{{ getEmail(pedido.instancia_cliente, pedido.cliente) }}</p>
                                </v-flex>
                            </v-layout>
                        </div>
                    </collapse-transition>
                </div>

                <div class="mb-5" v-if="!isPessoaFisica()">
                    <v-row class="primary--text ma-1 pointer" @click="sections.socios = !sections.socios">
                        <h2>Dados do(s) Sócio(s)</h2>
                        <v-spacer />
                        <v-icon color="primary" class="mt-1" :class="{ rotate90: sections.socios }">
                            chevron_right
                        </v-icon>
                    </v-row>
                    <v-divider />
                    <collapse-transition>
                        <div class="ma-1 my-3" v-show="sections.socios">
                            <v-layout wrap>
                                <v-flex xs12 md6>
                                    <label>{{ "Nome" }}</label>
                                    <p>
                                        {{ pedido.cliente_pedido.nome_completo }}
                                    </p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>{{ "CPF" }}</label>
                                    <p>
                                        {{ pedido.cliente_pedido.cpf || "-" }}
                                    </p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>Politicamente exposto</label>
                                    <p>{{ getPoliticamenteExposto() }}</p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>Beneficiário Final</label>
                                    <p>{{ pedido.beneficiario.cpf == pedido.cliente.cpf_socio ? "Sim" : "Não" }}</p>
                                </v-flex>
                                <v-flex xs12 md6 v-if="pedido.beneficiario.cpf !== pedido.cliente.cpf_socio">
                                    <label>Nome do beneficiario</label>
                                    <p>
                                        {{ pedido.beneficiario.nome_completo ? pedido.beneficiario.nome_completo :
                                            pedido.cliente.nome_completo || "-" }}
                                    </p>
                                </v-flex>
                                <v-flex xs12 md6 v-if="pedido.beneficiario.cpf !== pedido.cliente.cpf_socio">
                                    <label>CPF do beneficiario</label>
                                    <p>
                                        {{ pedido.beneficiario.cpf ? pedido.beneficiario.cpf : pedido.cliente.cpf_socio
                                            || "-" }}
                                    </p>
                                </v-flex>
                                <v-flex xs12 md6 v-if="pedido.beneficiario.cpf !== pedido.cliente.cpf_socio">
                                    <label>Politicamente exposto?</label>
                                    <p>
                                        {{ getBeneficiarioPoliticamenteExposto() ? getBeneficiarioPoliticamenteExposto()
                                            :
                                            getPoliticamenteExposto() || "-" }}
                                    </p>
                                </v-flex>
                            </v-layout>
                        </div>
                    </collapse-transition>
                </div>
                <div class="mb-5">
                    <v-row class="primary--text ma-1 pointer" @click="sections.endereco = !sections.endereco">
                        <h2>Endereço</h2>
                        <v-spacer />
                        <v-icon color="primary" class="mt-1" :class="{ rotate90: sections.endereco }">
                            chevron_right
                        </v-icon>
                    </v-row>
                    <v-divider />
                    <collapse-transition>
                        <div class="ma-1 my-3" v-show="sections.endereco">
                            <v-layout wrap>
                                <v-flex xs12 md6>
                                    <label>CEP</label>
                                    <p>{{ enderecos[0] ? getCep(enderecos[0]) : "-" }}</p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>Nome do logradouro</label>
                                    <p>{{ enderecos[0].endereco || "-" }}</p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>Número</label>
                                    <p>{{ enderecos[0].numero || "-" }}</p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>Complemento</label>
                                    <p>{{ enderecos[0].complemento || "-" }}</p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>Bairro</label>
                                    <p>{{ enderecos[0].bairro || "-" }}</p>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <label>Cidade / Estado</label>
                                    <p>{{ enderecos[0].cidade.nome || "" }} - {{ enderecos[0].cidade.uf || "" }}</p>
                                </v-flex>
                            </v-layout>
                        </div>
                    </collapse-transition>
                </div>
                <v-row class="primary--text ma-1">
                    <h2>Confirmações</h2>
                </v-row>
                <v-divider />
                <v-form ref="confirmacoes" class="mx-1 mt-3 mb-5">
                    <v-col>
                        <v-row class="mb-4">
                            <v-flex class="d-flex align-center" sm8 md9>
                                <label class="v-label regular-label pr-2" for="GroupDivulgacao">Autorizo a divulgação de
                                    meus dados
                                    cadastrais exclusivamente para os participantes do grupo de consórcio? *</label>
                            </v-flex>
                            <v-flex class="d-flex align-center" sm4 md3>
                                <v-radio-group id="GroupDivulgacao" v-model="pedido.autoriza_divulgar_dados_cadastrais"
                                               :rules="[$rules.selected]" row :disabled="!isVendaNaoGerada(pedido.status_pedido)">
                                    <v-row>
                                        <v-col cols="2">
                                            <v-radio id="RadioDivulgacaoSim" label="Sim" :value="true" />
                                        </v-col>
                                        <v-col cols="2">
                                            <v-radio style="margin-left: 25px" id="RadioDivulgacaoNao" label="Não"
                                                     :value="false" />
                                        </v-col>
                                    </v-row>
                                </v-radio-group>
                            </v-flex>
                        </v-row>
                        <v-row v-if="exibirOpcaoConsentimentoWhatsapp" class="mb-4">
                            <v-flex class="d-flex align-center" sm8 md9>
                                <label class="v-label regular-label pr-2" for="GroupWhatsapp">O Consorciado autoriza a
                                    Administradora a
                                    contatá-lo por aplicativo de mensagem, inclusive pelo WhatsApp, para formalizar o
                                    contrato de
                                    consórcio e encaminhar informações relativas a esse negócio e aos demais produtos e
                                    serviços
                                    ofertados? *</label>
                            </v-flex>
                            <v-flex class="d-flex align-center" sm4 md3>
                                <v-radio-group id="GroupWhatsapp" v-model="pedido.aceita_comunicacao_whatsapp"
                                               :rules="[$rules.selected]" row :disabled="!isVendaNaoGerada(pedido.status_pedido)">
                                    <v-row>
                                        <v-col cols="2">
                                            <v-radio id="RadioWhatsappSim" label="Sim" :value="true" />
                                        </v-col>
                                        <v-col cols="2">
                                            <v-radio style="margin-left: 25px" id="RadioWhatsappNao" label="Não"
                                                     :value="false" />
                                        </v-col>
                                    </v-row>
                                </v-radio-group>
                            </v-flex>
                        </v-row>
                    </v-col>
                    <div class="pt-1">
                        <v-flex xs12>
                            <v-select label="Declaro que a presente cota de consórcio é adquirida com o propósito de:"
                                      id="SelectFinalidade" class="required" item-text="descricao" item-value="id_finalidade"
                                      outlined :disabled="!isVendaNaoGerada(pedido.status_pedido)" :items="finalidades"
                                      :rules="[$rules.required]" v-model="pedido.id_finalidade" />
                        </v-flex>
                        <v-flex v-if="obrigatorio_preencher_tipo_cota" xs12>
                            <v-select label="Tipo de Cota:" id="SelectTipoCota" class="required" item-text="label"
                                      item-value="cd_tipo_cota" outlined :disabled="!isVendaNaoGerada(pedido.status_pedido)"
                                      :items="tipos_cota"
                                      :rules="[$rules.needToHaveThatAttributeFilled(tipo_cota_selecionado, 'cd_tipo_cota')]"
                                      :return-object="true" v-model="tipo_cota_selecionado" />
                        </v-flex>
                    </div>
                    <v-col class="text-center red--text mb-6">
                        Campos obrigatórios *
                    </v-col>
                    <v-layout row-padding class="responsive-grid">
                        <v-flex class="col" id="back-button-container">
                            <v-tooltip bottom color="white" v-if="isVendaNaoGerada(pedido.status_pedido)">
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on">
                                        <v-btn id="ButtonVoltar" :disabled="is_venda_analise || is_venda_reprovada || (pedido.status_pedido === StatusPedido.AprovadoAnaliseCredito) || (pedido.status_pedido === StatusPedido.PendenteAnaliseCredito)"
                                               block color="secondary" @click="voltar()"
                                               style="margin-left: 0;">Voltar</v-btn>
                                    </span>
                                </template>
                                <div v-if="is_venda_analise" style="color:#222">
                                    Aguardando análise.
                                </div>
                                <div v-else-if="is_venda_reprovada" style="color:#222">
                                    Venda cancelada.
                                </div>
                                <div v-else-if="(pedido.status_pedido === StatusPedido.AprovadoAnaliseCredito)" style="color:#222">
                                    Ação proibida por conter análise de crédito.
                                </div>
                                <div v-else-if="(pedido.status_pedido === StatusPedido.PendenteAnaliseCredito)" style="color:#222">
                                    Aguardando nova analise.
                                </div>
                            </v-tooltip>
                        </v-flex>
                        <v-flex class="col" id="delete-button-container">
                            <v-tooltip top color="white"
                                       v-if="pedido.status_pedido === StatusPedido.Rascunho && !remove_delete_sale_button">
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on">
                                        <v-btn id="ButtonApagarVenda" block color="error"
                                               :disabled="pedido.status_pedido !== StatusPedido.Rascunho || isVendaEmAnaliseCadastral(pedido)"
                                               @click="deletar()">
                                            Apagar Venda
                                        </v-btn>
                                    </span>
                                </template>
                                <div v-if="isVendaEmAnaliseCadastral(pedido)" class="tooltip-message">
                                    Ação bloqueada por conter análise cadastral
                                </div>
                            </v-tooltip>
                        </v-flex>
                        <v-flex class="col" id="continue-button-container">
                            <v-tooltip bottom color="white"
                                       v-if="(isVendaNaoGerada(pedido.status_pedido) || (!pedido.assinatura_obrigatoria && !pedido.pagamento_enviado)) && !is_venda_reprovada && !isVendaCancelada(pedido.status_pedido)">
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on">
                                        <v-btn id="ButtonProsseguir" block color="primary" @click="avancar()"
                                               style="margin-right: 0;">
                                            Prosseguir com a venda
                                        </v-btn>
                                    </span>
                                </template>
                            </v-tooltip>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-flex>
        </v-layout>
        <DialogAlterarDados v-model="show_dialog_alterar_dados" :consulta="pedido.analiseCredito" :tipo-pessoa="pedido.cliente.pessoa" :cliente="pedido.cliente" @alteracao-enviada="recarregarPedido"
        />
        <DialogDefenderDados v-model="show_dialog_defender_dados" :id-consulta="pedido.analiseCredito.id_consulta" @defesa-enviada="recarregarPedido" />
        <DialogConfirmarEmail v-model="dialog_email" :email="pedido.cliente.email" @enviar="atualizarEmail" />

        <DialogHistorico v-model="show_historico_boleto" tipo-historico="boleto"
                         :historico="pedido.historico_envio_boleto" />

        <DialogHistorico v-model="show_historico_link" tipo-historico="link" :historico="pedido.historico_envio_link" />

        <DialogHistoryReasonAutorization v-model="showHistoryAuth" :historico="historico_motivo" :title="'HISTÓRICO DE PENDÊNCIAS'" />

        <DialogHistorico v-model="show_historico_contrato" tipo-historico="contrato" :historico="historico_contrato" />
    </div>
</template>

<script>
  import { alert, notification, getNomeEmpresaPorIdEmpresa, isVendaNaoGerada, isVendaCancelada, getComissionadoNormalized, getDescricaoStatusContrato, unmask } from '@/plugins/helpers'
  import { FormasPagamento, OpcoesFuroDesc, PoliticamenteExposto, StatusPedido, TipoPessoa, StatusContrato } from '@/plugins/constants'
  import { cep, money, toDateBR } from '@/plugins/formatters'
  import DialogConfirmarEmail from '@/dialogs/DialogConfirmarEmail'
  import { get } from 'lodash'
  import { mapState } from 'vuex'
  import reenviarContratoMixin from '@/mixins/reenviarContratoMixin'
  import { sendAnalyticsEvent } from '@/plugins/googleAnalytics'
  import DialogHistorico from '@/dialogs/DialogHistorico'
  import creditAnalysis from '@/mixins/creditAnalysis'
  import detalhesAndResumo from '@/mixins/detalhesAndResumo'
  import { AlertTypes } from '@/plugins/alerts_types'
  import IndicadorDecisaoCredito from '../../../components/analise-credito/IndicadorDecisaoCredito.vue'
  import { pedido_default } from '../../../plugins/pedido_default'
  import ImagemBem from '../../../components/bem/ImagemBem.vue'
  import { icones_status_hashmap } from '../../../plugins/listaStatusStyles'
  import DadosDaCompra from '../../../fragments/InformacoesProposta/DadosDaCompra.vue'
  import { SituationAnalysisCredit } from '../../../plugins/constants'
  import deployValidation from '@/mixins/deployValidation'
  import telefonesMixin from '@/mixins/telefonesMixin'
  import emailMixin from '@/mixins/emailMixin'
  import definirGrandeNegocioMixin from '@/mixins/definirGrandeNegocioMixin'
  import DialogDefenderDados from '@/dialogs/DialogDefenderDados.vue'
  import DialogAlterarDados from '@/dialogs/DialogAlterarDados.vue'
  import DialogHistoryReasonAutorization from '@/views/painel/credit-analysis/consultation-reports-components/DialogHistoryReasonAutorization.vue'
  export default {
    name: 'Resumo',
    components: { DialogHistorico, DialogConfirmarEmail, IndicadorDecisaoCredito, ImagemBem, DadosDaCompra, DialogDefenderDados, DialogAlterarDados, DialogHistoryReasonAutorization },
    mixins: [reenviarContratoMixin, creditAnalysis, detalhesAndResumo, deployValidation, telefonesMixin, emailMixin, definirGrandeNegocioMixin],
    props: { value: Object },
    data: () => ({
      obrigatorio_preencher_tipo_cota: false,
      comissionado: '',
      tipo_cota_selecionado: null,
      reserva_valida: true,
      desconto: false,
      hasError: false,
      vl_grande_negocio: null,
      grande_negocio: false,
      sections: {
        cliente: true,
        endereco: false,
        socios: true
      },
      dialog_email: false,
      pedido: pedido_default,
      enderecos: [
        {
          id_endereco: '',
          id_cliente: '',
          cep: '',
          endereco: '',
          numero: '',
          complemento: '',
          bairro: '',
          estado: '',
          id_cidade: '',
          principal: '',
          ativo: '',
          cidade: {
            nome: ''
          }
        }
      ],
      finalidades: [],
      tipos_cota: [],
      documentos: [],
      historico_motivo: [],
      houve_pendencia: false,
      exibe_contrato: true,
      show_historico_boleto: false,
      show_historico_link: false,
      show_historico_contrato: false,
      show_dialog_defender_dados: false,
      show_dialog_alterar_dados: false,
      showHistoryAuth: false,
      historico_contrato: [],
      permite_flavor_todos_produtos: false,
      administradora: '',
      exibe_reenvio_whatsapp: false,
      exibirOpcaoConsentimentoWhatsapp: false
    }),
    computed: {
      ...mapState(['jornada_venda']),
      descricaoFinalidadeSelecionada () {
        return this.finalidades.filter(finalidade => finalidade.id_finalidade === this.pedido.id_finalidade)[0].descricao
      },
      OpcoesFuroDesc: () => OpcoesFuroDesc,
      StatusPedido: () => StatusPedido,
      TipoPessoa: () => TipoPessoa,
      StatusContrato: () => StatusContrato,
      /**
       * @return {boolean}
       */
      AguardandoPagamentoCliente () {
        return this.pedido.forma_pagamento === FormasPagamento.Link && !isVendaNaoGerada(this.pedido.status_pedido) && this.pedido.status_pedido !== StatusPedido.Cancelado && this.pedido.status_pedido !== StatusPedido.Pago && this.pedido.status_pedido !== StatusPedido.CanceladoNewcon
      },
      seguro () {
        return this.$session.get('configuracoes').seguro
      },
      dropdown_documentos_aberto: {
        get () {
          return this.documentos.length > 0
        },
        set (aberto) {
          if (!aberto) {
            this.documentos = []
          }
        }
      }
    },
    watch: {
      dropdown_documentos_aberto (aberto) {
        if (!aberto) {
          this.limparDocumentos()
        }
      }

    },
    async mounted () {
      this.permite_flavor_todos_produtos = !!this.$session.get('permite_venda_todos_produtos')
      this.exibe_reenvio_whatsapp = !!this.$session.get('exibe_reenvio_whatsapp')

      this.exibe_contrato = this.$session.get('exibe_contratos_sistema')
      await this.getPedido()
      if (this.pedido.analiseCredito.id_consulta) {
        await this.historicoPendencia(this.pedido.analiseCredito.id_consulta)
      }
      Promise.all([this.getFinalidades()])
      await this.getConfiguracaoGrandesNegocios()
      this.verificarGrandeNegocio()
    },
    methods: {
      async getPedido () {
        if (this.value && this.value.id_pedido) {
          try {
            const res = await this.$http.get(`/vendas/${this.value.id_pedido}?minimal=1`)
            this.desconto = res.data.desconto
            res.data.beneficiario = { ...this.pedido.beneficiario, ...res.data.beneficiario }
            res.data.cliente_pedido = { ...this.pedido.cliente_pedido, ...res.data.cliente_pedido }
            res.data.cliente = { ...this.pedido.cliente, ...res.data.cliente }
            res.data.produto = { ...this.pedido.produto, ...res.data.produto }
            res.data.bem = { ...this.pedido.bem, ...res.data.bem }
            res.data.grupo = { ...this.pedido.grupo, ...res.data.grupo }
            res.data.plano = { ...this.pedido.plano, ...res.data.plano }
            res.data.analiseCredito = { ...this.pedido.plano, ...res.data.analiseCredito }
            this.pedido = { ...this.pedido, ...res.data }
            this.exibirOpcaoConsentimentoWhatsapp = !!res.data.exibir_opcao_consentimento_whatsapp

            if (this.pedido.cliente.enderecos.length > 0) {
              this.enderecos = this.pedido.cliente.enderecos
            }
            if (this.pedido.status_pedido === StatusPedido.AguardandoDecisaoAnaliseCredito) {
              this.setVendaAnalise()
              if (this.pedido.analiseCredito.situacao === SituationAnalysisCredit.PENDENTE) {
                this.setVendaPendente()
              }
            } else if (this.pedido.status_pedido === StatusPedido.PendenteAnaliseCredito) {
              this.setVendaPendenciaCadastral()
            } else if (this.pedido.status_pedido === StatusPedido.ReprovadoAnaliseCredito) {
              this.setVendaReprovada()
            } else if (this.pedido.status_pedido === StatusPedido.AprovadoAnaliseCredito) {
              this.setVendaAprovada()
            }

            if (this.pedido.enviado) {
              this.$emit('finalizado')
            }

            if (this.pedido.seguro === null) {
              this.pedido.seguro = this.seguro.valor_padrao
            }

            if (this.pedido.msg_erro) {
              alert(this.pedido.msg_erro)
            } else {
              this.$emit('input', { ...this.value, ...this.pedido })
            }

            if (this.permite_flavor_todos_produtos) {
              this.administradora = getNomeEmpresaPorIdEmpresa(res.data.grupo.id_empresa)
            }
            await this.avisoPedido(this.value.id_pedido)
          } catch (err) {
            this.hasError = true
            notification(AlertTypes.ERROR, err, 'Não foi possível buscar a venda.')
          } finally {
            await this.getTipoCotas(this.pedido.produto.id_produto)
            this.obrigatorio_preencher_tipo_cota = this.tipos_cota.length > 0
          }
        } else {
          if (this.pedido.seguro === null) {
            this.pedido.seguro = this.seguro.valor_padrao
          }
        }
      },
      getDescricaoStatusContrato,
      async getFinalidades () {
        await this.$http.get('/finalidades').then(result => {
          this.finalidades = result.data.Finalidades
          this.finalidades.unshift({ id_finalidade: null, descricao: 'Selecione uma finalidade' })
        })
      },
      async getTipoCotas (id_produto) {
        await this.$http.get(`/tipo_cotas/produto/${id_produto}`).then(result => {
          if (result.data.tipos_cota.length > 0) {
            this.tipos_cota = result.data.tipos_cota
            if (this.tipos_cota.length === 1) {
              this.tipo_cota_selecionado = this.tipos_cota[0]
              return
            } else {
              this.tipos_cota.unshift({ tipo_cota: null, cd_tipo_cota: null, label: 'Selecione um tipo de cota' })
            }
            if (this.pedido.cd_tipo_cota) {
              const tipoCotaSelecionado = this.tipos_cota.find(tipo => tipo.cd_tipo_cota === this.pedido.cd_tipo_cota)
              if (tipoCotaSelecionado) {
                this.tipo_cota_selecionado = tipoCotaSelecionado
              }
            }
          }
        })
      },
      async getConfiguracaoGrandesNegocios () {
        try {
          const response = await this.$http.get('/grandes_negocios')

          this.vl_grande_negocio = response.data.vl_grande_negocio
        } catch (error) {
          let errorMessage = error.response?.data?.error || error.message
          notification(AlertTypes.ERROR, errorMessage)
        }
      },
      verificarGrandeNegocio () {
        this.calculaValorTotalSDNovaProposta(
          this.pedido.bem.valor_bem,
          this.pedido.grupo.taxa_adm,
          this.pedido.carrinho?.qt_cotas || 1
        )

        this.grande_negocio = this.calculaGrandeNegocio(
          this.pedido.cliente.saldo_devedor_cliente,
          this.vl_grande_negocio
        )
      },
      async historicoPendencia (id_consulta) {
        await this.$http
          .get(`/credit_analysis/history_reason/${id_consulta}`)
          .then(res => {
            this.historico_motivo = res.data
            this.houve_pendencia = res.data.some(
              motivo => motivo.situacao_antiga === SituationAnalysisCredit.PENDENCIA_CADASTRAL
            )
          })
          .catch(e => {
            notification('error', e, 'Não foi possível exibir os motivos.')
          })
      },
      abrirHistoricoPendencias () {
        sendAnalyticsEvent(this.$gtag, 'alterar_dados_pendentes', {
          id_pedido: this.pedido.id_pedido,
          hierarquia: this.$session.get('hierarquia_comercial'),
          valor_credito: this.pedido.analiseCredito.vl_credito,
          bem: this.pedido.bem.nome_bem,
          cliente: {
            cpf_cnpj: this.pedido.cliente.pessoa === TipoPessoa.Fisica ? unmask(this.pedido.cliente.cpf) : unmask(this.pedido.cliente.cnpj)
          }
        })

        this.showHistoryAuth = true
      },
      abrirModalDefesa () {
        this.show_dialog_defender_dados = true
      },
      abrirModalAlterarDados () {
        this.show_dialog_alterar_dados = true
      },
      isVendaEmAnaliseCadastral (pedido) {
        const statusEmAnalise = ['Analisar', 'Aprovado', 'Reprovado', 'Pendência Cadastral']
        return statusEmAnalise.includes(pedido.analiseCredito.situacao)
      },
      async recarregarPedido () {
        await this.getPedido()
      },
      isVendaCancelada (status_pedido) {
        return isVendaCancelada(status_pedido)
      },
      isPessoaFisica () {
        return this.pedido.cliente.pessoa === TipoPessoa.Fisica
      },
      cliente () {
        return (this.isPessoaFisica() ? this.pedido.cliente.nome_completo : this.pedido.cliente_pedido.razao_social) || '-'
      },
      nacionalidadeAtividade () {
        return (this.isPessoaFisica() ? this.pedido.cliente.nacionalidade : this.pedido.cliente.atividade.nome) || '-'
      },
      sexoNomeSocio () {
        return this.isPessoaFisica() ? _.startCase(this.pedido.cliente.genero) : '-'
      },
      nomeFantasia () {
        return this.pedido.cliente_pedido.nome_fantasia
      },
      async irParaReservas () {
        await this.$router.push({ name: 'reservas' })
      },
      getParcela () {
        let parcela = parseFloat(this.pedido.plano.vl_parcela_com_seguro) || 0
        if (this.pedido.seguro) {
          return money(parcela - (parcela * parseFloat(this.pedido.grupo.pe_seguro)) / 100)
        }
        return money(parcela)
      },
      getData (pedido) {
        let data = pedido.cliente.pessoa === TipoPessoa.Fisica ? pedido.cliente.data_nascimento : pedido.cliente_pedido.data_fundacao
        if (data) {
          return toDateBR(data)
        }
        return '-'
      },
      getMoney (pedido) {
        let renda = pedido.cliente.pessoa === TipoPessoa.Fisica ? pedido.cliente.renda : pedido.cliente.faturamento_medio
        if (renda) {
          return money(renda)
        }
        return '-'
      },
      async atualizarEmail (email) {
        const { id_cliente, email: email_antigo } = this.pedido.cliente

        if (email_antigo !== email) {
          await this.$http.patch(`/clientes/${id_cliente}/email`, { email })

          this.pedido.cliente.email = email

          this.$emit('input', this.pedido)
        }

        if (this.pedido.forma_pagamento === FormasPagamento.Link) {
          this.reenviarEmail()
        } else {
          this.emitirBoleto()
        }
      },
      getCep (endereco) {
        const _cep = endereco.cep
        return _cep ? cep(_cep) : '-'
      },
      async reenviarEmail () {
        await this.$http.post('/proposta/linkpagamento/reenviar', { id_pedido: this.pedido.id_pedido })
        notification('success', 'Link de pagamento enviado com sucesso!')
      },
      gerarNovoBoleto () {
        alert({
          text: `Ao gerar um novo boleto, será registrado no DDA do cliente (caso o mesmo tenha aderido) essa nova cobrança, caso queira somente reenviar o boleto da venda, utilizar o botão “Visualizar Boleto”.`,
          buttons: {
            Cancelar: () => true,
            Confirmar: async () => this.openDialogEmail()
          }
        })
      },
      openDialogEmail () {
        this.dialog_email = true
      },
      getPoliticamenteExposto () {
        if (this.pedido.cliente.politicamente_exposto) {
          return this.pedido.cliente.politicamente_exposto === PoliticamenteExposto.NaoPoliticamenteExposto ? 'Não' : 'Sim'
        }
        return '-'
      },
      getBeneficiarioPoliticamenteExposto () {
        if (this.pedido.beneficiario.politicamente_exposto) {
          return this.pedido.beneficiario.politicamente_exposto === PoliticamenteExposto.NaoPoliticamenteExposto ? 'Não' : 'Sim'
        }
        return '-'
      },
      voltar () {
        const href = window.location.href
        if (href.includes('cadastro') || href.includes('iniciar-venda')) {
          if (this.pedido.id_reserva && this.pedido.reserva.completa) {
            alert({
              text: 'Alterar as condições comerciais poderá fazer com que a consulta de crédito seja refeita. Deseja prosseguir?',
              buttons: {
                Fechar: () => { },
                Confirmar: () => this.$emit('prevPage')
              }
            })
          } else if (!isVendaNaoGerada(this.pedido.status_pedido)) {
            this.$router.back()
          } else {
            alert({
              text: 'Alterar as condições comerciais poderá fazer com que a consulta de crédito seja refeita. Deseja prosseguir?',
              buttons: {
                Fechar: () => { },
                Confirmar: () => this.$emit('prevPage')
              }
            })
          }
        } else {
          this.$router.push({ name: 'minhas-vendas' })
        }
      },
      fluxoProduto () {
        return this.$route.name === 'iniciar-venda'
      },
      deletar () {
        alert({
          text: 'Tem certeza que deseja apagar a venda? Esta ação não pode ser desfeita',
          buttons: {
            Cancelar: () => true,
            Confirmar: () => {
              this.sendAnalytics(true)
              this.$http
                .delete(`vendas/${this.pedido.id_pedido}`)
                .then(() => {
                  alert({
                    text: 'Venda apagada com sucesso!',
                    buttons: {
                      OK: () => {
                        this.$emit('finalizado')
                        this.$router.push({ name: 'minhas-vendas' })
                      }
                    }
                  })
                })
                .catch(err => notification(AlertTypes.ERROR, err, 'Não foi possível apagar a venda.'))
            }
          }
        })
      },
      avancar () {
        const radio_seguro = this.$refs.seguro_radio
        const confirmacoes = this.$refs.confirmacoes
        if (this.seguro.exibir && !radio_seguro.validate(true)) {
          notification('warning', 'Por favor, decida sobre o seguro')
          return
        }

        if (typeof this.pedido.autoriza_divulgar_dados_cadastrais !== 'boolean') {
          // Se o valor não for boolean ele não foi iniciado
          notification('warning', 'Por favor decida sobre a autorização para divulgação dos dados cadastrais')
          return
        }
        if (this.pedido.exibir_opcao_consentimento_whatsapp && typeof this.pedido.aceita_comunicacao_whatsapp !== 'boolean') {
          // Se o valor não for boolean ele não foi iniciado
          notification('warning', 'Por favor decida sobre a autorização para contatar o cliente via aplicativo de mensagem')
          return
        }
        if (!this.pedido.exibir_opcao_consentimento_whatsapp) {
          this.pedido.aceita_comunicacao_whatsapp = true
        }
        if (confirmacoes.validate()) {
          this.pedido.plano.valor_parcela = parseFloat(this.pedido.plano.vl_parcela_com_seguro) - (!this.pedido.seguro * parseFloat(this.pedido.grupo.pe_seguro) * parseFloat(this.pedido.plano.vl_parcela_com_seguro)) / 100
          this.pedido.identificador_representante_tribanco = this.$session.get('identificador_representante_tribanco')
          const comissionadoData = getComissionadoNormalized(this.$session.get('id_comissionado_venda'), this.$session.get('comissionados'), this.$session.get('vendas_backoffice'))
          this.pedido.flavor_atual = this.$session.get('flavor')
          this.pedido.id_comissionado = comissionadoData.id_comissionado
          this.pedido.cd_comissionado = comissionadoData.cd_comissionado
          this.pedido.nm_comissionado = comissionadoData.nm_comissionado
          this.pedido.nm_ponto_venda = this.$session.get('nm_ponto_venda')
          this.pedido.cd_ponto_venda = this.$session.get('cd_ponto_venda')
          this.pedido.cd_tipo_cota = this.tipo_cota_selecionado ? this.tipo_cota_selecionado.cd_tipo_cota : null
          this.pedido.tipo_cota = this.tipo_cota_selecionado ? this.tipo_cota_selecionado.tipo_cota : null
          this.pedido.grande_negocio = this.grande_negocio
          this.pedido.id_empresa = this.pedido.grupo?.id_empresa
          const ambiente = this.$session.get('ambiente')
          if (ambiente && ambiente.unidade_condicoes_venda) {
            this.pedido.unidade_condicoes_venda = ambiente.unidade_condicoes_venda
          }
          this.sendAnalytics()
          this.$http
            .post('/vendas', this.pedido)
            .then(() => {
              return this.$http.patch(`/vendas/${this.pedido.id_pedido}/salvarseguro`, { seguro: this.pedido.seguro })
            })
            .then(async () => {
              if (!(await this.validarDadosDaVenda(this.pedido.id_pedido))) {
                return
              }
              if (!(await this.validarDeploy())) {
                return
              }
              if (!(await this.validarIndexadorBem())) {
                return
              }
              if (!(await this.checkAnaliseCadastral(this.pedido.id_pedido, this.pedido.grupo_pontual, this.pedido.grupo_praja))) {
                this.$emit('input', this.pedido)
                return
              }
              if (!(await this.verificarCamposParaAnaliseCadastral())) {
                return
              }

              const href = window.location.href
              if (href.includes('cadastro') || href.includes('iniciar-venda')) {
                this.$emit('input', this.pedido)
                this.$emit('nextPage')
              } else {
                this.pedido.tela = 'selecionar_prazo_parcela'
                this.$router.push({ name: 'cadastro', params: this.pedido })
              }
            })
            .catch((error) => {
              if (error.response && error.response.data) {
                const { Msg_Erro, Codigo_Erro } = error.response.data
                notification('error', Msg_Erro || 'Erro desconhecido')
                console.error(`Erro ${Codigo_Erro}: ${Msg_Erro}`)
              } else {
                notification('error', 'Não foi possível salvar a venda.')
                console.error(error)
              }
            })
        }
      },
      sendAnalytics (deleteSale) {
        sendAnalyticsEvent(this.$gtag, deleteSale ? 'menu_confirmar_apagarVenda' : 'confirmar_venda_etapa1', {
          nome_bem: this.pedido.bem.nome_bem,
          cod_bem: this.pedido.bem.id_bem,
          plano_venda: this.pedido.plano.nome_plano,
          valor_bem: this.pedido.bem.valor_bem,
          valor_parcela: this.pedido.plano.valor_parcela,
          qtd_parcelas: this.pedido.plano.pz_restante,
          finalidade_compra: this.descricaoFinalidadeSelecionada,
          grupo: this.pedido.bem.cd_grupo || this.pedido.cd_grupo,
          data_nascimento: this.pedido.cliente.data_nascimento,
          renda_usuario: this.pedido.cliente.renda,
          source_menu: this.jornada_venda
        })
      },
      toggleSeguro () {
        if (this.seguro.permite_editar) {
          if (!this.pedido.seguro) {
            alert({
              text: 'O Seguro Prestamista da direito ao sorteio mensal do Prêmio Pontualidade, que é uma recompensa em dinheiro que não tem vínculo com a cota, por isso, poderá utiliza-la da forma que desejar. Também é uma garantia de que a inadimplência poderá ser evitada, no caso de sinistro.',
              buttons: {
                'Desistir do seguro': () => true,
                'Aceitar o seguro': () => {
                  this.pedido.seguro = true
                }
              }
            })
          }
        } else {
          this.$nextTick(function () {
            this.pedido.seguro = this.seguro.valor_padrao
          })
        }
      },
      verBoleto () {
        window.open(`${this.ws}/boleto/${this.pedido.id_documento}`)
      },
      emitirBoleto () {
        this.$http
          .post('/proposta/boleto/enviar', {
            id_pedido: this.pedido.id_pedido,
            email: this.pedido.cliente.email,
            reenvio: true,
            vendedor: true
          })
          .then(() => {
            notification('success', 'Forma de pagamento enviada com sucesso! Em breve você receberá um e-mail com o boleto.')
          })
          .catch(err => {
            this.getHistoricoBoleto()
            notification('error', err, 'Não foi possível reemitir o boleto')
          })
      },
      exibirBotoesBoleto () {
        return [StatusPedido.Finalizado, StatusPedido.Enviado, StatusPedido.AguardandoPagamento].includes(this.pedido.status_pedido) && this.pedido.forma_pagamento === FormasPagamento.Boleto
      },
      getIconStatusContrato (status) {
        if (icones_status_hashmap[status]) {
          return icones_status_hashmap[status]
        }
        return 'work_off'
      },
      compartilharDocumentos () {
        alert({
          text: 'Deseja compartilhar todos os documentos do contrato via e-mail?',
          buttons: {
            Nao: { text: 'Não' },
            Sim: async () => {
              try {
                await this.$http.post(`/contrato/compartilhar/${this.pedido.contrato.id_contrato}`)
                notification('success', 'Contrato agendado para compartilhamento com sucesso!')
              } catch (e) {
                notification('error', e, 'Não foi possível compartilhar os documentos')
              }
            }
          }
        })
      },
      isVendaNaoGerada (status_venda) {
        return isVendaNaoGerada(status_venda)
      },
      async validarIndexadorBem () {
        const { data } = await this.$http.get(`/validar_indexador_bem/${this.pedido.bem.id_bem}`)
        if (!data.valido) {
          notification(AlertTypes.ERROR, 'Não é possível prosseguir com a venda devido ao índice de correção associado ao bem. Entre em contato com a Área de Suporte e informe o erro.')
          return false
        }
        return true
      },
      reenviarContrato () {
        this.showDialogReenviaContrato(this.pedido.contrato.id_contrato, this.pedido.whatsapp, this.exibe_reenvio_whatsapp)
      },
      async visualizarDocumentos () {
        try {
          const { data } = await this.$http.get(`/contrato/documentos/${this.pedido.contrato.hash_contrato}`)
          this.documentos = data
        } catch (e) {
          const status_code = get(e, 'response.status', 500)
          if (status_code === 404) {
            notification('error', 'Falha ao identificar documentos da proposta. Tente novamente mais tarde.')
          } else {
            notification('error', e, 'Não foi possível visualizar os documentos')
          }
        }
      },
      visualizarDocumento (documento) {
        window.open(`${this.ws}/contrato/baixar/${this.pedido.contrato.hash_contrato}/${documento}`)
      },
      limparDocumentos () {
        // Espero 500ms pra garantir que o usuário consiga baixar o documento antes de deletar ele
        setTimeout(async () => {
          this.$http.delete(`/contrato/documentos/${this.pedido.contrato.id_contrato}`)
          this.documentos = []
        }, 500)
      },
      async getHistoricoBoleto () {
        try {
          const { data } = await this.$http.get(`/vendas/${this.pedido.id_pedido}/historicoboleto`)
          this.pedido.historico_envio_boleto = data
          this.show_historico_boleto = true
        } catch (e) {
          notification('error', 'Não possível atualizar o histórico de envio de boletos ao cliente. É possível que você veja uma listagem defasada')
        }
      },
      async getHistoricoLink () {
        try {
          const { data } = await this.$http.get(`/vendas/${this.pedido.id_pedido}/historicolink`)
          this.pedido.historico_envio_link = data
          this.show_historico_link = true
        } catch (e) {
          notification('error', 'Não foi possível atualizar o histórico de envio de link ao cliente. É possível que você veja uma listagem defasada')
        }
      },
      async getHistoricoReenvio () {
        this.$http
          .get(`/contrato/historico_contrato/${this.pedido.id_pedido}`)
          .then(result => {
            this.historico_contrato = result.data
            this.show_historico_contrato = true
          })
          .catch(err => notification('error', err, 'Não foi possível buscar o contrato!'))
      }
    }
  }
</script>

<style lang="scss" scoped>
label {
    font-size: 1rem;
    color: var(--darkgray);
}

p {
    color: var(--dark);
    font-size: 1.1rem;
}

.lista-documentos {
    width: 200px;
    z-index: 1;

    .theme--light.v-text-field--outlined {
        margin-top: 0;
    }
}

.regular-label {
    font-size: 13px;
    line-height: 18px;
}

.tooltip-message {
    background-color: #00441f;
    padding: 1.5rem;
    font-size: 1rem;
    border-radius: 1rem;
    text-align: center;

    &::after {
        content: "";
        position: absolute;
        top: 90%;
        left: 50%;
        transform: translateX(-50%);
        border-width: 1rem;
        border-style: solid;
        border-color: #00441f transparent transparent transparent;
    }
}

.responsive-grid {
    display: grid;

    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr;
    grid-template-areas: "back delete continue";

    #back-button-container {
        grid-area: back;
        max-width: 100%;
    }

    #delete-button-container {
        grid-area: delete;
    }

    #continue-button-container {
        grid-area: continue;
    }
}

@media (max-width: 350px) {
    .responsive-grid {
        grid-template-columns: 1fr;
        grid-template-rows: 1fr 1fr 1fr;
        grid-template-areas:
            "continue"
            "delete"
            "back";
        gap: 1rem 0px;
    }
}

@media (max-width: 625px) and (min-width: 350px) {
    .responsive-grid {
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 1fr;
        gap: 1rem 0px;
        grid-template-areas:
            "continue continue"
            "back delete";
    }
}
</style>
